<div [formGroup]="form">

    <ngx-slider [id]="field.name" [formControlName]="field.name" [(highValue)]="highValue" [(value)]="value"
        [options]="options"></ngx-slider>
   
</div>